import { survey } from '../data/survey';
import React, { useEffect, useState } from 'react';
import useFormHook from '../hooks/useFormHook'
import MarketoForm from './MarketoForm'

export default function Calculator() {
    const { values, updateValue } = useFormHook({})
    const [count, setCount] = useState(0)
	const [disabled, setDisabled] = useState(true)
    const totalQs = survey.length

    const [results, setResults] = useState([
        {Q1: 0},
		{Q2: 0},
		{Q3: 0},
		{Q4: 0},
		{Q5: 0},
		{Q6: 0},
		{Q7: 0},
    ])
    const [level, setLevel] = useState(0)

    const revealNext = () => {
		if (!disabled) {
			setCount(count + 1)
		}
	}

	const revealPrev = () => {
		setCount(count - 1)
	}

    useEffect(() => {
		if (values[count] === undefined) {
			setDisabled(true)
			return
		}
		setDisabled(false)
	}, [values, count])

    const findTheAnswer = (qsId, questions, scoreValue) => {
        const answer = questions[qsId].options.map(row => {
            if(scoreValue === row.score) {
                return row.choice
            }
            return null
        })
        return answer.find(element => element !== null)
    }

    useEffect(() => {
        if (Object.entries(values).length === totalQs) {
            const newValues = { ...values }
            for (const [key, value] of Object.entries(newValues)) {
				newValues[key] = parseInt(value)
			}
            const totalScore = Object.values(newValues).reduce((prevValue, currentValue) => prevValue + currentValue)

            if(totalScore <= 4) {
                setLevel(1)
            }
            if(totalScore >= 5 && totalScore <=9) {
                setLevel(2)
            }
            if(totalScore >= 10 && totalScore <=14) {
                setLevel(3)
            }
            if(totalScore >= 15 && totalScore <=19) {
                setLevel(4)
            }
            if(totalScore >= 20) {
                setLevel(5)
            }
            for (const [key, value] of Object.entries(newValues)) {
                results[key] = {
                    "question_id": parseInt(key),
                    "answer_id": findTheAnswer(parseInt(key), survey, value),
                    "answer_score": value,
                }
                setResults(results)
            }
        }
	}, [values, totalQs, results])

    const submitData = () => {
        const payload = {
            results,
            level
        }
        return payload
    }
    
    return (
        <section className="calculator">
            <h2 style={{display: count === totalQs ? 'block' : 'none' }} className="l2-heading">Take the Project to Product Maturity Assessment</h2>
            <div className='calculator-container'>
                <h2 style={{display: count === totalQs ? 'none' : 'block' }} className="l2-heading">Take the Project to Product Maturity Assessment</h2>
                <article>
                    {count < totalQs && (
                        <>
                            <label htmlFor="progress-bar">
                                Progress: {count + 1}/{totalQs} <br />
                                <progress id="progress-bar" value={(count * 100) / totalQs} max="100" />
                            </label>
                            <p>
                                Choose the answer that best describes the prevailing current state for the majority of
                                cases.
                            </p>
                        </>
                    )}
                    {survey.slice(count, count + 1).map((row) =>
                        row.question && row.question.length !== 0 && row.options && row.options.length !== 0 ? (
                            <fieldset key={row.id}>
                                <legend>
                                    <h3>{row.question}</h3>
                                </legend>
                                {row.options.map((option, index) => (
                                    <label key={option.choice}>
                                        <input
                                            type="radio"
                                            name={count}
                                            value={option.score}
                                            onChange={updateValue}
                                            checked={index === parseInt(values[count])}
                                        />
                                        {option.choice}
                                    </label>
                                ))}
                            </fieldset>
                        ) : null
				    )}
                </article>

                {count === 0 && (
                    <div className="calc-btn-container">
                        <button className="button primary next" type="button" onClick={revealNext} aria-disabled={disabled}>
                            Next
                        </button>
                    </div>
                )}
                {count > 0 && count < totalQs && (
                    <div className="calc-btn-container">
                        <button className="button primary next" type="button" onClick={revealNext} aria-disabled={disabled}>
                            Next
                        </button>
                        <button className="button secondary back" type="button" onClick={revealPrev}>
                            Back
                        </button>
                    </div>
                )}
                <div style={{display: count === totalQs ? 'block' : 'none' }}>
                    <h3 className="l2-heading">You're one step away from knowing your stage!</h3>
                    <MarketoForm baseUrl='//info.planview.com' munchkinId='456-QCH-520' formId='3501' handleForm={submitData}/>
                    <div className="calc-btn-container">
                        <button className="button secondary back absolute-back" type="button" onClick={revealPrev}>
                            Back
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}